module.exports = __webpack_public_path__ + "img/12@2x.d6a34ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/cooperation/12@2x.png
// module id = qY5a
// module chunks = 0